import { create } from "zustand";
import { retrieveHomeData, updateHomeData } from "./actions";


type DataStoreProps = {
    loading                : boolean    
    data                   : { [key:string]:any} | null
    retrieveData    : () => void
    updateData             : (data:any) => Promise<void>
    error                  : string  
}

export const useHomeStore = create<DataStoreProps>( (set,getState) => ({
    data: null,
    loading: false,
    error: "",
    retrieveData() {
        set( state => ({loading: true, error: ""}))
        retrieveHomeData()
            .then( data => set( state => ({data:data, loading:false})))
            .catch( err => set(state => ({loading:false, error:err})))
    },
    async updateData(data) {
        try {
            await updateHomeData(data)
            set( state => ({data:data}))
        } catch (error) {
            set( state => ({error:"Failed updating data"}))
        }
    },
}))

